<template>
  <fragment>
    <default-header :h2="$t('dashboard.title')"></default-header>
    <div class="innerContent justifyContentToEnd speedometer">
      <div class="main-message-box">
        {{$t('dashboard.hello')}} {{ user.firstName}}, {{$t('dashboard.excited')}}
        <router-link :to="{name: 'New Client'}">{{$t('dashboard.startProcess')}}</router-link>
        &nbsp;{{$t('dashboard.withNewClient')}}
        <i class="triangle"></i>
      </div>
      <div class="additionalPadding">
        <button
          class="btn btn-primary fw onlyFirstUppercase mb-2"
          @click.prevent="newClient"
        >{{$t('dashboard.startProcessButton')}}</button>
      </div>
    </div>
    <bottom-navigation></bottom-navigation>
  </fragment>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import DefaultHeader from '@/partials/DefaultHeader';
import BottomNavigation from '@/partials/BottomNavigation';

export default {
  name: 'Dashboard',
  components: {
    DefaultHeader,
    BottomNavigation
  },
  data() {
    return {
      email: '',
      password: ''
    };
  },
  beforeMount() {
    this.$store.dispatch('getUser');
  },

  mounted() {
    $('.paddingToHide').css('padding-left', '0px');
    $('.paddingToHide').css('padding-right', '0px');
  },
  destroyed() {
    $('.paddingToHide').css('padding-right', '15px');
    $('.paddingToHide').css('padding-left', '15px');
  },
  methods: {
    ...mapActions(['loginAction', 'logoutAction', 'setMessage']),
    logout: function() {
      this.logoutAction();
      this.setMessage({ status: 'info', text: this.$i18n.t('dashboard.loggedOut') });
      this.$router.push({ name: 'Login' });
    },
    newClient: function() {
      this.$router.push({ name: 'New Client' });
    }
  },
  computed: {
    ...mapGetters({
      message: 'getMessage',
      user: 'getUser'
    })
  }
};
</script>

<style scoped lang="scss">
.main-message-box {
  background: #ededed;
  border-radius: 5px;
  padding: 15px 20px;
  position: absolute;
  top: 50%;
  left: 30px;
  right: 30px;
  text-align: center;
  transform: translateY(-50%);

  .triangle {
    position: absolute;
    top: 50%;
    left: -10px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 7.5px 10px 7.5px 0;
    border-color: transparent #ededed transparent transparent;
  }

  a {
    font-weight: bold;
    color: inherit;
  }
}

.main-container {
  height: calc(100vh - 200px);
}
</style>

